export const buildProvenance = { "commitHash": "6bb526bd26d816ae669600cf08969c9c3d39bd55", "branchName": "refs/heads/release/2024.1", "buildDate": "2024-09-26T06:31:36.661Z", "version": "2024.1.13038" };
